import { CustomCheckbox } from "@/components/ui/Checkbox";
import { Dispatch, SetStateAction, useState } from "react";

import CreatorGradientIcon from "@/assets/icons/CreatorGraident.svg";
import { CustomButton } from "@/components/ui/Buttons";
import { usePricingSolution } from "@/hooks/useCurrencyByLocation";
function getCurrencySymbol(currency: string): string {
  const symbols: { [key: string]: string } = {
    INR: "₹",
    USD: "$",
    EUR: "€",
    GBP: "£",
  };
  return symbols[currency] || "$"; // Default to "$" if symbol is not found
}
type Currency = "EUR" | "USD" | "INR";
const creatorCanvasPrice = {
  shootOnlyPrice: { INR: 1800, USD: 70, EUR: 70 },
  INR: 2100,
  USD: 80,
  EUR: 80,
};
const CreatorConfirmation = ({
  setOpen,
  onClick,
  isLoading,
  setShowBenchMark,
  jobPrice,
  currency,
}: {
  currency: string;
  jobPrice: number;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onClick: (deliverables: string) => void;
  isLoading: boolean;
  setShowBenchMark: Dispatch<SetStateAction<boolean>>;
}) => {
  const [deliverables, setDeliverables] = useState<
    "shoot_only" | "shoot_and_edit" | null
  >(null);
  const currencySymbol = getCurrencySymbol(currency);
  // const { ucdT } = usePricingSolution();

  const shootOnlyPrice =
    creatorCanvasPrice?.shootOnlyPrice[currency as Currency] || 0;

  const shoot_and_editPrice = jobPrice;

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-x-3">
        <CreatorGradientIcon />

        <h4 className="text-base font-semibold leading-5 tracking-normal">
          Creator-Led Project
        </h4>
        <div className="px-2.5 py-[3px] fulfilled-by-creator-gradient-border">
          <p className="text-[#ED5E00] text-[13px] tracking-[-0.5%] leading-[18px] italic">
            Fulfilled by Creator
          </p>
        </div>
      </div>

      <div className="text-sm text-[#475467]">
        <p className="text-[#475467] text-sm">
          You’ll manage{" "}
          <span className="text-black font-medium">
            recording, editing, and final delivery
          </span>
          .
        </p>
        <p className="mt-6">
          To earn the full {currencySymbol}
          {jobPrice}, your edit must meet{" "}
          <span className="font-medium text-black">our benchmark</span>. If you
          submit raw footage or the edit falls short after review, payout is{" "}
          {currencySymbol} {shootOnlyPrice}.{" "}
        </p>
      </div>
      <CustomButton
        variant="outline"
        color="#003B83"
        fontWeight="500"
        fontSize="14px"
        border="0px"
        padding="0px"
        className="underline underline-offset-4"
        onClick={() => setShowBenchMark(true)}
      >
        See editing benchmark →
      </CustomButton>

      <div>
        <p className="text-[#475467] text-base mb-5">Choose your scope:</p>
        <div className="flex items-center gap-x-2">
          <CustomCheckbox
            checked={deliverables === "shoot_and_edit"}
            onChange={() => setDeliverables("shoot_and_edit")}
          />
          <p className="text-black text-base font-medium leading-5">
            Shoot + Edit —{" "}
            <span className="text-[#667085] font-normal">
              {currencySymbol}
              {jobPrice} (meets
            </span>{" "}
            editing benchmark){" "}
          </p>
        </div>
        <div className="flex items-center gap-x-2 mt-6">
          <CustomCheckbox
            checked={deliverables === "shoot_only"}
            onChange={() => setDeliverables("shoot_only")}
          />
          <p className="text-[#667085] text-base font-medium leading-5">
            Shoot only — {currencySymbol}
            {shootOnlyPrice} (raw footage delivery)
          </p>
        </div>
      </div>
      <div className="flex flex-col md:flex-row w-full gap-4 mt-6">
        <CustomButton
          onClick={() => setOpen(false)}
          variant="outline"
          color="#344054"
          fontSize="14px"
          fontWeight="500"
          padding="10px 24px"
          border="1px solid #E8EBEE"
          borderRadius="8px"
          className="leading-5 w-full"
        >
          Cancel
        </CustomButton>
        <CustomButton
          fontSize="14px"
          onClick={() => onClick(deliverables as string)}
          fontWeight="500"
          disabled={isLoading || !deliverables}
          padding="10px 24px"
          backgroundColor="#17457D"
          borderRadius="8px"
          className="leading-5 w-full"
        >
          {isLoading ? "Loading" : "Confirm"}
        </CustomButton>
      </div>
    </div>
  );
};

export default CreatorConfirmation;
